import React from "react";

function FormProfile({ profile, updateData }) {
  function handleChange(e) {
    updateData({ category: "profile", newValue: e.target.value });
  }
  return (
    <>
      <label htmlFor="name">Profile:</label>
      <textarea
        className="border xl:w-64 2xl:w-80 lg:w-48 border-slate-200 rounded-sm h-40 justify-start px-2 py-0.5 hover:border-slate-400 focus:border-slate-700 transition outline-0"
        type="text"
        name="name"
        onChange={handleChange}
        defaultValue={profile.profileSummary}
      />
    </>
  );
}

export default FormProfile;
